export var visitationPending = function visitationPending(siteApi) {
  return {
    index: function index(params) {
      return siteApi.get('/visitation-pending', {
        params: params
      });
    },
    put: function put(id, note, timeLimit) {
      return siteApi.put('/visitation-pending', {
        id: id,
        note: note,
        timeLimit: timeLimit
      });
    },
    approve: function approve(id, note, timeLimit) {
      return siteApi.put('/visitation-pending/approve', {
        id: id,
        note: note,
        timeLimit: timeLimit
      });
    },
    reject: function reject(id, note) {
      return siteApi.put('/visitation-pending/reject', {
        id: id,
        note: note
      });
    }
  };
};